import { handleActions } from 'redux-actions';
import { Report, ReportId, ReportMap } from 'types';
import {
    ReportsLoadRequestAction, ReportsLoadSuccessAction, ReportsLoadFailureAction,
    DeleteReportRequestAction, DeleteReportSuccessAction, DeleteReportFailureAction,
    ReportAddedUpdatedAction,
} from 'actions/reportActions';
import { LogoutAction } from 'actions/shellActions';

export type State = Readonly<{
    data: Readonly<ReportMap>;
    loading: boolean;
    error: Error | null;
}>;

export const initialState = Object.freeze<State>({
    data: {},
    loading: false,
    error: null,
});

export type ReducerAction =
    ReportsLoadRequestAction
    | ReportsLoadSuccessAction
    | ReportsLoadFailureAction
    | DeleteReportRequestAction
    | DeleteReportSuccessAction
    | DeleteReportFailureAction
    | ReportAddedUpdatedAction
    // Shell Actions
    | LogoutAction
;

const updateReport = (state: State, reportId: ReportId, fn: (r: Report) => Report): State => ({
    ...state,
    data: {
        ...state.data,
        [`${reportId}`]: fn(state.data[`${reportId}`]),
    },
});

export type Reducer = (state: State, action: ReducerAction) => State;

export const reportReducer: Reducer = handleActions({
    REPORTS_LOAD_REQUEST(state: State, action: ReportsLoadRequestAction) {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    REPORTS_LOAD_SUCCESS(state: State, action: ReportsLoadSuccessAction) {
        return {
            ...state,
            data: action.payload,
            loading: false,
            error: null,
        };
    },

    REPORTS_LOAD_FAILURE(state: State, action: ReportsLoadFailureAction) {
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    },

    DELETE_REPORT_REQUEST(state: State, action: DeleteReportRequestAction) {
        const reportId = action.payload;
        return updateReport(state, reportId, report => ({
            ...report,
            deleted: true, // Optimistic deletion (just remove from UI but keep in memory)
        }));
    },
    
    DELETE_REPORT_SUCCESS(state: State, action: DeleteReportSuccessAction) {
        const { reportId } = action.meta;
        const data = { ...state.data } as ReportMap; // Create a clone
        delete data[`${reportId}`]; // Remove the entry
        return {
            ...state,
            data,
        };
    },
    
    DELETE_REPORT_FAILURE(state: State, action: DeleteReportFailureAction) {
        const { reportId } = action.meta;
        return updateReport(state, reportId, report => ({
            ...report,
            deleted: false, // Put the entry back in the UI
        }));
    },

    REPORT_ADDED_UPDATED(state: State, action: ReportAddedUpdatedAction) {
        const report = action.payload;
        return updateReport(state, report.reportId, _ => report);
    },

    
    //
    //  Shell Actions
    //
    LOGOUT(state: State, action: LogoutAction) {
        return initialState;
    },

// tslint:disable-next-line:no-any
} as any, initialState) as any;



// WEBPACK FOOTER //
// ./src/reducers/reportReducer.ts